import styled from "styled-components"

export const Overlay = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const Dialog = styled.div`
  position: relative;
  background: white;
  width: 90%;
  max-width: 400px;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;

  h1 {
    color: red;
    margin-bottom: 10px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    color: red;

    height: 80px;
    width: 80px;
    margin-right: 15px;
  }
`

export const DialogMessage = styled.p`
  font-size: 1rem;
  color: red;
  font-weight: normal;
  margin: 0 0 20px;
`

export const Button = styled.button`
  flex: 1;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: normal;
  border-radius: 5px;
  border: 1px solid red;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: white;
  color: red;

  &:hover {
    background-color: red;
  }
`

export const CloseButton = styled.button`
  position: absolute; /* Posiciona o botão dentro do .dialog-content */
  top: 8px; /* Espaçamento do topo */
  right: 8px; /* Espaçamento da direita */
  background: none;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;

  svg {
    color: red;
    width: 20px;
    height: 20px;
  }

  :hover {
    color: ${(props) => props.theme.colors.secondaryBlue};
  }
`
